// extracted by mini-css-extract-plugin
export var addToCartButton = "_l3-b";
export var arrowButtonContainer = "_l3-9";
export var arrowButtonIcon = "_l3-a";
export var carouselArrowButton = "_l3-6";
export var carouselElementContainer = "_l3-1";
export var left = "_l3-7";
export var productDisplayCarouselContainer = "_l3-0";
export var productTileContainer = "_l3-2";
export var productTileImage = "_l3-4";
export var productTileImageContainer = "_l3-3";
export var productTileTitle = "_l3-5";
export var right = "_l3-8";
export var sliderOverflow = "_l3-c";